export function getExerciseResultsData(resultsBlocks, data, images) {
  const allData = data["research"];
  const resultsData = [];
  resultsBlocks.forEach(item => {
    const block = item.block;
    let result = allData[item.id];
    let objImages = null;
    if (block.type === 'imagesChoice' || block.type === 'dropdown') {
      let resultImages = block.type === 'dropdown' ? result.images : result;
      if (!Array.isArray(resultImages)) {
        resultImages = resultImages ? [resultImages] : [];
      }
      objImages = resultImages
        ? Object.values(resultImages).flatMap(id => images.find(image => image.id === parseInt(id) && image.blockId === parseInt(item.id)))
        : [];
    }
    const obj = {
      result: result,
      type: block.type,
      zone: item.zone,
      resultOrder: item.resultOrder,
      block: block,
      images: objImages,
    };
    resultsData.push(obj);
  });
  return resultsData;
}
